import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { MagicwandFillIcon } from '@/icons';
import { useOpenAiBuilderChat } from '@/views/build/features/ai-builder-chat/hooks';
import { useAiBuilderChatPanelSelector } from '@/views/build/features/ai-builder-chat/stores';
import { useEditMode } from '../../focus/useIsEditMode';
export const useAiGenerateTool = () => {
  const {
    t
  } = useTranslation(['build']);
  const {
    panelOpen
  } = useAiBuilderChatPanelSelector();
  const openAiBuilderChat = useOpenAiBuilderChat();
  const {
    onEditModeChange
  } = useEditMode();
  if (panelOpen) return null;
  return {
    icon: <MagicwandFillIcon size="md" fill={ICON_COLOR.default} />,
    label: String(t('build:build.ai.createQuiz')),
    onClick: () => {
      onEditModeChange(true);
      openAiBuilderChat({
        entry: 'chat',
        source: 'quiz_card'
      });
    }
  };
};